import { apiCaller, cancelListToken } from "src/util/apiCaller";
import { useEffect, useState } from "react";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import { MessageStatusError } from "src/util/MessageStatus";
import { get, toNumber } from "lodash";
import { Button, Card, Col, Divider, Layout, Modal, Row, Table } from "antd";
import {
  checkVaiTroUserLogin,
  longToDate,
  StringValueReturn
} from "src/util/Commom";
import cookie from "react-cookies";
import { ColumnsType } from "antd/es/table";
import { useAppSelector } from "src/app/hooks";
import { selectUser } from "src/appRedux/reducers/userReducer";
import {
  CheckCircleFilled,
  CloseCircleOutlined,
  LeftOutlined,
  RetweetOutlined,
  SendOutlined
} from "@ant-design/icons";
import { selectData } from "src/appRedux/reducers/commonApiReducer";
interface NhomTaiLieu {
  id: number;
  tenNhomTuLieu: string;
}

const ThongTinHinhAnhDetail = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const useInfo = useAppSelector(selectUser);
  const [itemView, setItemView] = useState<any>({});
  const { hinhanhid, idnhomtulieu } = useParams();
  const [tuLieuFile, setTuLieuFile] = useState([]);
  const [isLoadTable, setIsLoadTable] = useState(false);
  const [loadingGuiDuyet, setLoadingGuiDuyet] = useState(false);
  const isDuyetXuatBan = checkVaiTroUserLogin(useInfo, "DUYET_XUAT_BAN");
  const isAdmin = checkVaiTroUserLogin(useInfo, "ADMIN");
  const [trangThai, setTrangThai] = useState();
  const [itemGopY, setItemGopY] = useState<any>([]);
  const [tenNhomTuLieu, setTenNhomTuLieu] = useState("");

  const columns: ColumnsType<any> = [
    {
      title: "STT",
      dataIndex: "key",
      key: "key",
      width: "5%",
      align: "center",
      render: (text, record, index) => <span>{index + 1}</span>
    },
    { title: "Tên tác giả", dataIndex: "tacGia", key: "tacGia" },
    { title: "Mô tả", dataIndex: "moTa", key: "moTa", width: "25%" },
    {
      title: "File tài liệu",
      dataIndex: "",
      key: "file",
      width: "30%",
      render: (item) => renderFile(item)
    }
  ];

  const columnsGopY: ColumnsType<any> = [
    {
      title: "STT",
      dataIndex: "key",
      key: "key",
      width: "5%",
      align: "center",
      render: (text, record, index) => <span>{index + 1}</span>
    },
    {
      title: "Tên người góp ý",
      dataIndex: "nguoiGopY",
      key: "nguoiGopY",
      render: (text, record) => renderTitle(text, record)
    },
    { title: "Email", dataIndex: "email", key: "email", width: "25%" },
    {
      title: "Ngày góp ý",
      dataIndex: "ngayGopY",
      key: "ngayGopY",
      width: "20%",
      render: (item) => longToDate(item)
    }
  ];

  const [columsTableGopY, setColumsTableGopY] = useState(columnsGopY);
  const listNhomTaiLieu = useAppSelector(selectData)
  .listNhomTaiLieu as NhomTaiLieu[];

  useEffect(() => {
    if (isDuyetXuatBan || isAdmin) {
      columnsGopY.push({
        title: "Hành động",
        dataIndex: "",
        key: "x",
        align: "center",
        width: "10%",
        render: (item) => actionContent(item)
      });
      setColumsTableGopY(columnsGopY);
    }
    if (idnhomtulieu && listNhomTaiLieu) {
      const itemNhomTL = listNhomTaiLieu.find(
        (value: any) => value.id === parseInt(idnhomtulieu, 10)
      );
      const tenNhomTuLieu = itemNhomTL ? itemNhomTL.tenNhomTuLieu : "";
      setTenNhomTuLieu(tenNhomTuLieu);
    }
    getInfo();
    getTuLieuDinhKem();
    getGopY();
  }, [idnhomtulieu]);

  useEffect(() => {
    return () => {
      cancelListToken(["infoTuLieu"]);
    };
  }, []);

  /**
   * renderTitle: hiển thị màu title table
   * @param {String} text
   * @param {object} record
   * @param {String} title
   * @memberof DonThuDaNhapList
   */
  const renderTitle = (text: any, record: any) => {
    if (isDuyetXuatBan || isAdmin) {
      return (
        <span
          onClick={() =>
            navigate(
              `/quan-tri/${record.id}/tra-loi-gop-y/idtulieu/${record.tuLieu.id}`,
              { state: { itemData: record } }
            )
          }
          style={{ cursor: "pointer", color: "#0065ff" }}
          title="Xem chi tiết"
        >
          {text}
        </span>
      );
    } else {
      return <span>{text}</span>;
    }
  };

  /**
   * getInfo : Lấy thông tin
   * @memberof  videoForm
   */
  const getInfo = async () => {
    if (location.state && location.state.itemData) {
      // Nếu có dữ liệu truyền sang
      const res = location.state.itemData;
      setItemView(res);
      setTrangThai(res.trangThai);
    } else {
      const configAPI = {
        url: `api/tulieu/${hinhanhid}`,
        method: "GET",
        value: "",
        apiType: "DETAIL",
        getName: "infoTuLieu"
      };
      const response = await apiCaller(configAPI);
      try {
        if (
          response?.data &&
          (response.status === 200 || response.status === 201)
        ) {
          const res = response?.data;
          setItemView(res);
          setTrangThai(res.trangThai);
        } else {
          MessageStatusError(toNumber(response?.status));
        }
      } catch (error) {
        // Xử lý lỗi khi lưu dữ liệu không thành công
      }
    }
  };

  const getTuLieuDinhKem = async () => {
    setIsLoadTable(true);
    const configAPI = {
      url: `api/tulieufile/${hinhanhid}`,
      method: "GET",
      value: null,
      apiType: "LIST",
      getName: "listTuLieuFile"
    } as any;
    const response = await apiCaller(configAPI);
    try {
      if (
        response?.data &&
        (response.status === 200 || response.status === 201)
      ) {
        const data = get(response, "data", []);
        setTuLieuFile(data as any);
        setIsLoadTable(false);
      } else {
        MessageStatusError(toNumber(response?.status));
      }
    } finally {
      setIsLoadTable(false);
    }
  };

  const getGopY = async () => {
    const configAPI = {
      url: `api/tulieugopys?idtulieu=${hinhanhid}`,
      method: "GET",
      value: null,
      apiType: "LIST",
      getName: "listGopY"
    } as any;
    const response = await apiCaller(configAPI);
    try {
      if (
        response?.data &&
        (response.status === 200 || response.status === 201)
      ) {
        const data = get(response.data, "content", []);
        setItemGopY(data as any);
      } else {
        MessageStatusError(toNumber(response?.status));
      }
    } finally {
    }
  };

  const renderFile = (item: any) => {
    return (
      <span
        onClick={() => downloadFile(item)}
        style={{
          color: "blue",
          cursor: "pointer",
          whiteSpace: "normal"
        }}
      >
        {item.tenFile} <br />
      </span>
    );
  };

  /**
   * downloadFile: Tải file
   * @param {object} item
   */
  const downloadFile = (item: any) => {
    fetch(`${item.duongDanFile}`, {
      headers: {
        Authorization: "Bearer ".concat(cookie.load("accessTokenTVDTBDT"))
      }
    }).then((response) => {
      response.blob().then((blob) => {
        const url = window.URL.createObjectURL(blob);
        const a = document.createElement("a");
        a.href = url;
        a.download = item.tenFile;
        a.click();
      });
    });
  };

  const HtmlContent = ({ htmlContent }: any) => {
    return (
      <div>
        <Divider
          orientation="left"
          orientationMargin="0"
          style={{ borderColor: "rgb(193 190 190)", marginTop: 5 }}
        >
          <b>Chi tiết</b>
        </Divider>
        <span dangerouslySetInnerHTML={{ __html: htmlContent }} />
      </div>
    );
  };

  /**
   * goBack : quay lại trang danh sách
   * @memberof  videoForm
   */
  const goBack = () => {
    navigate(`/hinh-anh/idnhomtulieu/${idnhomtulieu}`);
  };

  const handleGuiDuyet = (trangthai: number, type: string) => {
    const title = type === "gui" ? "gửi" : type === "huy" ? "hủy" : "";
    Modal.confirm({
      width: 500,
      title: "THÔNG BÁO",
      content: `Bạn sẽ ${title} xuất bản tài liệu này. Nhấn Đồng ý để xác nhận.`,
      onOk(e) {
        e();
        handleSubmit(trangthai);
      },
      okText: "Đồng ý",
      onCancel() {},
      cancelText: "Hủy"
    });
  };

  const handleSubmit = async (TT: any) => {
    setLoadingGuiDuyet(true);
    const configAPI = {
      url: `api/tulieu/${hinhanhid}/${TT}`,
      method: "PUT",
      value: null,
      apiType: "EDIT",
      getName: "editTrangThai"
    } as any;
    const response = await apiCaller(configAPI);
    try {
      if (
        response?.data &&
        (response.status === 200 || response.status === 201)
      ) {
        goBack();
      } else {
        MessageStatusError(toNumber(response?.status));
      }
    } finally {
      setLoadingGuiDuyet(false);
    }
  };

  const actionContent = (item: any) => {
    return (
      <Button
        style={{ marginBottom: 5 }}
        className="heading-button-addnew btn"
        type="primary"
        onClick={() => onClickTraLoi(item)}
        icon={<RetweetOutlined />}
      >
        Trả lời
      </Button>
    );
  };

  const onClickTraLoi = (item: any) => {
    const pathname = `/quan-tri/${item.id}/tra-loi-gop-y/idtulieu/${item.tuLieu.id}`;
    navigate(pathname, { state: { itemData: item } });
  };

  /**
   * expandRow: Hiển thị dữ liệu khi expand row
   * @param {object} item
   * @memberof QuanLyKeHoachList
   */
  const expandRow = (item: any) => (
    <Row gutter={18}>
      <StringValueReturn
        text="Nội dung góp ý"
        type="text"
        value={item.noiDungGopY}
      />
    </Row>
  );
  return (
    <div>
      <Layout>
        <div style={{ display: "flex" }}>
          <Col md={12}>
            <h2 style={{ color: "black", fontSize: 20, marginTop: 10 }}>
              Chi tiết {tenNhomTuLieu}
            </h2>
          </Col>
        </div>
        <Card className="chitiet-nhomtulieu">
          <h2>{itemView.tenTuLieu}</h2>
          <Row gutter={24}>
            <Col md={10} xs={24}>
              <img
                alt="Tải ảnh lên"
                src={itemView.anhDaiDien || "src/assets/images/placeholder.jpg"}
                style={{ maxWidth: "100%", height: "auto" }}
              />
            </Col>
            <Col md={14} xs={24}>
              <p>
                <b>Loại tài liệu: </b>
                {itemView?.loaiTuLieu?.tenLoaiTuLieu}
              </p>
              <p>
                <b>Dân tộc: </b>
                {itemView?.danToc?.tenGoi}
              </p>
              <p>
                <b>Tác giả: </b>
                {itemView.tacGia}
              </p>
              <p>
                <b>Người đăng: </b>
                {itemView.tenNguoiDang}
              </p>
              <p>
                <b>Hạn lưu trữ: </b>
                {itemView?.hanLuuTru?.tenHanLuuTru}
              </p>
              <p>
                <b>Ngày bắt đầu lưu trữ: </b>
                {longToDate(itemView.ngayBatDauLT)}
              </p>
              <p>
                <b>Ngày kết thúc lưu trữ: </b>
                {longToDate(itemView.ngayKetThucLT)}
              </p>
            </Col>
            <Col md={24} xs={24}>
              <p>
                <b>Mô tả: </b>
                {itemView.moTa}
              </p>
            </Col>
            <Col md={24} xs={24}>
              {<HtmlContent htmlContent={itemView.chiTiet} />}
            </Col>
          </Row>
          <h2>Tài liệu đính kèm</h2>
          <Table
            style={{ marginBottom: 20 }}
            rowKey={"id"}
            bordered
            columns={columns}
            className="qti-table-wrapper gx-table-responsive"
            dataSource={tuLieuFile}
            rowClassName={(record, index) =>
              index % 2 === 0 ? "qti-table-row-background" : ""
            }
            size="middle"
            pagination={false}
            loading={isLoadTable}
            scroll={{ x: 800 }}
          />
          {itemGopY.length > 0 && (
            <>
              <h2>Thông tin góp ý</h2>
              <Table
                style={{ marginBottom: 20 }}
                rowKey={"id"}
                bordered
                columns={columsTableGopY}
                className="qti-table-wrapper gx-table-responsive"
                expandRowByClick={true}
                expandedRowRender={expandRow}
                dataSource={itemGopY}
                rowClassName={(record, index) =>
                  index % 2 === 0 ? "qti-table-row-background" : ""
                }
                size="middle"
                pagination={false}
                loading={isLoadTable}
                scroll={{ x: 800 }}
              />
            </>
          )}
          <Row gutter={24}></Row>
          <hr />
          {hinhanhid && (
            <div style={{ textAlign: "center", padding: 10 }}>
              <Button onClick={goBack} htmlType="submit">
                <LeftOutlined /> Quay về
              </Button>
              {(trangThai === 1 || trangThai === 4) && (
                <Button
                  style={{ marginLeft: "15px" }}
                  onClick={() => handleGuiDuyet(2, "gui")}
                  type="primary"
                  htmlType="submit"
                >
                  <SendOutlined />
                  Gửi duyệt xuất bản
                </Button>
              )}
              {(trangThai === 1 || trangThai === 2) &&
                (isDuyetXuatBan || isAdmin) && (
                  <Button
                    style={{ marginLeft: "15px" }}
                    className="heading-button-addnew btn"
                    type="primary"
                    onClick={() => handleGuiDuyet(3, "xuat")}
                    icon={<CheckCircleFilled />}
                    loading={loadingGuiDuyet}
                  >
                    Duyệt xuất bản
                  </Button>
                )}
              {(trangThai === 1 || trangThai === 2 || trangThai === 3) &&
                (isDuyetXuatBan || isAdmin) && (
                  <Button
                    style={{ marginLeft: "15px" }}
                    type="primary"
                    onClick={() => handleGuiDuyet(4, "huy")}
                    icon={<CloseCircleOutlined />}
                    color="danger"
                    variant="solid"
                  >
                    Hủy xuất bản
                  </Button>
                )}
            </div>
          )}
        </Card>
      </Layout>
    </div>
  );
};

export default ThongTinHinhAnhDetail;
